// Publicados desactualizados, en sus dos unidades: cuántos updates y a cuántos clientes les toca.
// Estado y el informe de integridad lo escriben igual, así el mismo caso no es "3" en un lado y "1" en el otro.
export const outdatedCount = (files, clients) => files > 0
    ? `${files} ${files === 1 ? 'update' : 'updates'} (${clients} ${clients === 1 ? 'cliente' : 'clientes'})`
    : '0';
